import { render, staticRenderFns } from "./WCard.vue?vue&type=template&id=0b555a18&scoped=true"
import script from "./WCard.vue?vue&type=script&lang=js"
export * from "./WCard.vue?vue&type=script&lang=js"
import style0 from "./WCard.vue?vue&type=style&index=0&id=0b555a18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b555a18",
  null
  
)

export default component.exports